import { ButtonLinkLegacy } from '@/components/ui/button-link-legacy'
import { Container } from '@/components/ui/container'
import { Spinner } from '@/components/ui/spinner'
import { useTranslation } from '@/translations/i18n'

export const SsoRedirect = () => {
	const { t } = useTranslation()

	return (
		<Container>
			<div className='flex h-full items-center justify-center'>
				<div className='flex w-[360px] flex-col items-center text-center'>
					<Spinner className='fill-neutral-500' size={48} />
					<h3 className='mt-6 font-semibold text-display-sm text-neutral-900'>
						{t('redirect:title')}
					</h3>
					<p className='my-2 mb-14 text-md'>
						{t('redirect:subtitle')}
					</p>
					<div className='flex h-full items-center justify-center gap-1'>
						<small className='text-sm'>
							{t('redirect:cta_pre')}
						</small>
						<ButtonLinkLegacy
							className='px-0!'
							to={'/redirect'}
							variant='tertiary'
						>
							{t('redirect:cta')}
						</ButtonLinkLegacy>
					</div>
				</div>
			</div>
		</Container>
	)
}

SsoRedirect.displayName = 'SsoRedirect'
